import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

import Button from 'components/common/Button';

const styles = theme => ({
  root: {
    position: 'sticky',
    zIndex: 1,
    top: 64,
    padding: '16px 8px',
    marginTop: -16,
    marginRight: -8,
    marginLeft: -8,
    backgroundColor: theme.palette.grey[100],
    zIndex: 30,
    [theme.breakpoints.down('sm')]: {
      padding: '8px 8px',
      marginTop: -8,
      width: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    },
  },
});

const TabNavigation = ({ items, classes }) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <div>
    {items.map(item => (
      <Button
        key={item.href}
        nav
        href={item.href}
      >
        {item.text}
      </Button>
    ))}
    </div>
  </Toolbar>
);

TabNavigation.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};


export default withStyles(styles)(TabNavigation);



// WEBPACK FOOTER //
// ./src/components/common/TabNavigation/TabNavigation.js